import { render, staticRenderFns } from "./educationPlanPop.vue?vue&type=template&id=1e65882a"
import script from "./educationPlanPop.vue?vue&type=script&lang=js"
export * from "./educationPlanPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e65882a')) {
      api.createRecord('1e65882a', component.options)
    } else {
      api.reload('1e65882a', component.options)
    }
    module.hot.accept("./educationPlanPop.vue?vue&type=template&id=1e65882a", function () {
      api.rerender('1e65882a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/result/educationPlanPop.vue"
export default component.exports